import React from "react";
import { customizeConfig, updateConfig } from "../models/plotConfig";
const initial = {
    grafosConfig: {},
    updateGrafosConfig: () => { },
    update: () => { },
    updateCustomFolder: () => { },
    resetCustom: () => { },
    disabledButtonList: [""],
};
export const GraphConfigurationContext = React.createContext(initial);
export const GraphConfigurationProvider = ({ initialData, disabledButtonList = [], children, }) => {
    const [data, setData] = React.useState(initialData);
    React.useEffect(() => {
        setData(initialData);
    }, [initialData]);
    const updateGrafosConfig = React.useCallback((newGraph, graphId, selectorFolderType) => {
        const nextData = updateConfig(data, newGraph, graphId, selectorFolderType);
        setData(nextData);
    }, [data]);
    const update = React.useCallback((nextData) => {
        setData(nextData);
    }, []);
    const updateCustomFolder = React.useCallback((selectorList) => {
        if (JSON.stringify(selectorList) !==
            JSON.stringify(data.customSelectorFolderList[0].selectorList)) {
            const nextData = customizeConfig(data, selectorList);
            setData(nextData);
        }
    }, [data]);
    const resetCustom = React.useCallback(() => {
        const nextData = customizeConfig(data, initialData.customSelectorFolderList[0].selectorList);
        setData(nextData);
    }, [data]);
    const value = {
        grafosConfig: data,
        updateGrafosConfig,
        update,
        updateCustomFolder,
        resetCustom,
        disabledButtonList,
    };
    return (React.createElement(GraphConfigurationContext.Provider, { value: value }, children));
};
//# sourceMappingURL=index.js.map